module.exports = __webpack_public_path__ + "static/media/Hansief.4b9a1310.otf";